import React from 'react';
import {Link} from 'react-router-dom'
import NO_AVA_BIG from 'styles/img/no-ava-big.png';

const ProviderContactsInfo = ({provider}) => {
  return (
    <div className="contacts col-12 col-md-3">
      <div className="inner-top-block">
        <div className="card-avatar-wrap">
          <div className="card-avatar-wrap-inner">
            {
              provider.profile_logo_url ?
                <img src={provider.profile_logo_url} alt="avatar"/>
                :
                <img src={NO_AVA_BIG} alt="avatar" className="no-ava"/>
            }
          </div>
        </div>
        <div className="name-block">
          <div className="fullname">
            {provider.name}
          </div>
        </div>
      </div>
      <div className="inner-contact-block">
        <div className="email-block">
          <div className="title">Email:</div>
          <div className="email">{provider.email}</div>
        </div>
        <div className="phone-block">
          <div className="title">Phone:</div>
          <div className="phone">{provider.phone}</div>
        </div>
        <div className="website-block">
          <div className="title">Website:</div>
          <div className="website"><Link to={`${provider.website}`} target="_blank">{provider.website}</Link></div>
        </div>
        <ul className="contact-links">
          { provider.facebook_link &&
            <li>
              <Link to={`${provider.facebook_link}`} target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"/>
                </svg>
              </Link>
            </li>
          }
          {
            provider.linkedin_link &&
            <li>
              <Link to={`${provider.linkedin_link}`} target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
                </svg>
              </Link>
            </li>
          }
          {
            provider.twitter_link &&
            <li>
              <Link to={`${provider.twitter_link}`} target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m12.71 6.33c.48-.4 1.04-.88 1.29-1.41-.41.21-.9.34-1.44.41.5-.36.91-.83 1.12-1.47-.52.28-1.05.52-1.71.64-1.55-1.87-5.26-.35-4.6 2.45-2.61-.16-4.2-1.34-5.52-2.79-.75 1.22-.1 3.07.79 3.58-.46-.03-.81-.17-1.14-.33.04 1.54.89 2.28 2.08 2.68-.36.07-.76.09-1.14.03.37 1.07 1.14 1.74 2.46 1.88-.9.76-2.56 1.29-3.9 1.08 1.15.73 2.46 1.31 4.28 1.23 4.41-.2 7.36-3.36 7.43-7.98z"/>
                </svg>
              </Link>
            </li>
          }

        </ul>
      </div>
    </div>
  )
}

export default ProviderContactsInfo



// WEBPACK FOOTER //
// ./src/components/provider/ProviderContactsInfo.jsx